import { render, staticRenderFns } from "./LandingCardOccupation.vue?vue&type=template&id=9d0a3d90&scoped=true&"
import script from "./LandingCardOccupation.vue?vue&type=script&lang=js&"
export * from "./LandingCardOccupation.vue?vue&type=script&lang=js&"
import style0 from "./LandingCardOccupation.vue?vue&type=style&index=0&id=9d0a3d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0a3d90",
  null
  
)

export default component.exports